import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MasterActions } from './configuration.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@core/services/configuration.service';

@Injectable()
export class MasterEffects {
  private actions$ = inject(Actions);
  private configurationService = inject(ConfigurationService);
  private translateService = inject(TranslateService);

  getMasterList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadMasterList),
      mergeMap((data) =>
        this.configurationService.getMasterList(data.key, data.data).pipe(
          map((response) =>
            response.success
              ? MasterActions.loadMasterListSuccess({ response, key: data.key })
              : MasterActions.loadMasterListFailure({
                  error: response,
                  key: data.key,
                })
          ),
          catchError((error) =>
            of(
              MasterActions.loadMasterListFailure({
                key: data.key,
                error: {
                  error,
                  success: false,
                  message: this.translateService.instant(
                    'Something went wrong'
                  ),
                },
              })
            )
          )
        )
      )
    )
  );

  updateMasters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.addEditMaster),
      mergeMap((data) =>
        this.configurationService.editMaster(data.key, data.data).pipe(
          map((response) => {
            if (response.success) {
              return MasterActions.updateMasterSuccess({
                response,
                key: data.key,
              });
            } else
              return MasterActions.updateMasterFailure({
                error: response,
                key: data.key,
              });
          }),
          catchError((error) =>
            of(
              MasterActions.updateMasterFailure({
                error: {
                  error,
                  success: false,
                  message: this.translateService.instant(
                    'Something went wrong'
                  ),
                },
                key: data.key,
              })
            )
          )
        )
      )
    )
  );

  deleteMaster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.deleteMaster),
      mergeMap((data) =>
        this.configurationService.deleteMaster(data.key, data.id).pipe(
          map((response) =>
            response.success
              ? MasterActions.deleteMasterSuccess({
                  key: data.key,
                  response: {
                    ...response,
                    id: data.id,
                  },
                })
              : MasterActions.deleteMasterFailure({
                  error: response,
                  key: data.key,
                })
          ),
          catchError((error) =>
            of(
              MasterActions.deleteMasterFailure({
                error: {
                  error,
                  success: false,
                  message: this.translateService.instant(
                    'Something went wrong'
                  ),
                },
                key: data.key,
              })
            )
          )
        )
      )
    )
  );

  getVehicleChecklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.loadDynamicVehicleChecklist),
      mergeMap((data) =>
        this.configurationService.getVehicleChecklist(data).pipe(
          map((response) =>
            response.success
              ? MasterActions.loadDynamicVehicleChecklistSuccess(response)
              : MasterActions.loadDynamicVehicleChecklistFailure(response)
          ),
          catchError((error) =>
            of(
              MasterActions.loadDynamicVehicleChecklistFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  updatevehicleChecklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MasterActions.addEditDynamicVehicleChecklist),
      mergeMap((data) =>
        this.configurationService.editVehicleChecklist(data).pipe(
          map((response) =>
            response.success
              ? MasterActions.addEditDynamicVehicleChecklistSuccess(response)
              : MasterActions.addEditDynamicVehicleChecklistFailure(response)
          ),
          catchError((error) =>
            of(
              MasterActions.addEditDynamicVehicleChecklistFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
